/**
 * Created by ah on 04/01/17.
 */
import api from '../apiClient';
import {Actions} from '../constants';
import {defaultAsyncActionFactory} from './action-utils'

export const loadAssignees = defaultAsyncActionFactory(
    Actions.GET_ASSIGNEES,
    'assignees',
    api.getAssignees
);


// WEBPACK FOOTER //
// ./src/model/action-creators/assignee-actions.js